import { DateAdapter } from "@/infrastructure/adapters/dayJs";
import { DateService, NumberFormatterService } from "@/core/services";
import { NumberFormatterAdapter } from "@/infrastructure/adapters/number";
import { NumberFormatType } from "@/core/types";
import { Purchaser, PurchaserProps } from "@/core/entities/lookup";
import { Deduction, DeductionProps } from "@/core/entities/deduction/deduction";

export interface ApprovalRemittanceProps {
  remittanceId: number;
  checkNo: string;
  checkDate: string | null;
  deductedAmount: number;
  pendingCount: number;
  purchaser: PurchaserProps | null;
  deductions: DeductionProps[];
}

export class ApprovalRemittance {
  private readonly _remittanceId: number;
  private readonly _checkNo: string;
  private readonly _checkDate: string | null;
  private readonly _deductedAmount: number;
  private readonly _pendingCount: number;
  private readonly _purchaser: PurchaserProps | null;
  private readonly _deductions: Deduction[];

  constructor(props: ApprovalRemittanceProps) {
    this._remittanceId = props.remittanceId;
    this._checkNo = props.checkNo;
    this._checkDate = props.checkDate;
    this._deductedAmount = props.deductedAmount;
    this._pendingCount = props.pendingCount;
    this._purchaser = props.purchaser;
    this._deductions = (props.deductions ?? []).map(deduction => new Deduction(deduction));
  }

  get key(): number {
    return this._remittanceId;
  }

  get remittanceId(): number {
    return this._remittanceId;
  }

  get checkNumber(): string {
    return this._checkNo;
  }

  get checkDate(): string | null {
    return this._checkDate;
  }

  public checkDateFormatted(format: string): string {
    if (!this._checkDate) return "-";
    return new DateService(new DateAdapter()).format(this._checkDate, format);
  }

  get deductedAmount(): number {
    return this._deductedAmount;
  }

  public deductedAmountFormatted(format: NumberFormatType): string {
    return new NumberFormatterService(new NumberFormatterAdapter()).format(this._deductedAmount, format);
  }

  get pendingCount(): number {
    return this._pendingCount;
  }

  get purchaser(): Purchaser | null {
    return this._purchaser ? new Purchaser(this._purchaser) : null;
  }

  get deductions(): Deduction[] {
    return this._deductions;
  }
}
